import { render } from "./AbsenceModal.vue?vue&type=template&id=4e4d05b8&scoped=true&ts=true"
import script from "./AbsenceModal.vue?vue&type=script&lang=ts"
export * from "./AbsenceModal.vue?vue&type=script&lang=ts"

import "./AbsenceModal.vue?vue&type=style&index=0&id=4e4d05b8&lang=css"
import "./AbsenceModal.vue?vue&type=style&index=1&id=4e4d05b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e4d05b8"]])

export default __exports__